// 引入api
import { fun_PostAction } from "@/api";
// 默认导出
export default {
  // 数据存储对象
  data: () => {
    return {
      // 表单字段
      form: {
        id: null, // id
        projectName: null, // 项目名称
        projectCode: null, // 项目编号
        sectionId: null, // 项目包编号
        sectionName: null, // 项目包名称
        purchaseUnit: null, // 采购单位
        purchaseLink: null, // 采购单位联系方式
        contractAmount: null,
        budgetAmount: null,
        purchaseUnitCode: null,
        state: null,
        contractNum: null, //合同号
        purchaseType: null,
        corpCode: null,
        corpName: null,
        corpPhone: null
      },
      // 详情表单基础数据
      formConfigList: [
        {
          label: "项目包名称：",
          value: "sectionName",
          type: "input",
          required: true,
          disabled: true
        },
        {
          label: "",
          type: "slot",
          slotName: "btn"
        },
        {
          label: "包编号：",
          value: "sectionId",
          type: "input",
          required: true,
          disabled: true
        },
        {
          label: "项目编号：",
          value: "projectCode",
          type: "input",
          required: true,
          disabled: true
        },
        {
          label: "项目名称：",
          value: "projectName",
          type: "input",
          required: true,
          disabled: true
        },
        {
          label: "采购单位：",
          value: "purchaseUnit",
          type: "input",
          required: true,
          disabled: true
        },
        {
          label: "采购人联系方式：",
          value: "purchaseLink",
          type: "input",
          required: true,
          disabled: true
        },
        {
          label: "合同金额（万元）：",
          value: "contractAmount",
          type: "input",
          required: true,
          disabled: false
        }
      ],
      // 保存按钮loading
      loadingBtn: false,
      // 合同号
      number: null,
      // 富文本编辑器
      agreementContent: null,
      dialogVisibles: false,
      // 列表loading初始状态
      loading: false,
      //抽取按钮lodding状态
      extractBtn: false,
      // 采购单位和代理机构弹出框
      formLists: {
        projectName: null, // 项目名称
        projectCode: null, // 项目编号
        sectionCode: null, // 项目包编号
        sectionName: null, // 项目包名称
        purchaseUnit: null, // 采购单位
        contractAmount: null,
        budgetAmount: null,
        purchaseUnitCode: null,
        purchaseLink: null,
        purchaseType: null,
        corpCode: null,
        corpName: null,
        corpPhone: null
      },
      // 查询表单字段
      searchForm: {
        sectionName: null // projectCode
      },
      // 查询表单
      formSearchList: [
        {
          type: "input",
          label: "项目包名称：",
          value: "sectionName",
          placeholder: "请输入"
        }
      ],
      // 表格基础数据
      tableColumns: [
        {
          label: "包编号",
          prop: "sectionCode",
          isShow: true
        },
        {
          label: "项目包名称",
          prop: "sectionName"
        },
        {
          label: "项目编号",
          prop: "projectCode"
        },
        {
          label: "项目名称",
          prop: "projectName"
        }
      ],
      // 表格数据
      tableData: [],
      // 分页
      reqPageData: {
        current: 1, // 页码
        size: 10 // 每页条数
      },
      total: 0 // 总条数
    };
  },

  // 模板编译完成
  mounted() {
    // 获取项目信息详情
    const type = this.$route.query.type;
    // 是否是详情
    if (type && type !== "add") {
      // 获取id
      this.form.id = this.$route.query.id;
      // 获取项目信息详情
      this.fun_GetDetails();
    }
  },

  // 自定义方法
  methods: {
    /**
     * 获取项目信息
     * @author 付翔
     */
    async fun_GetDetails() {
      let res = await fun_PostAction(
        "/purchaseContract/detail?id=" + this.form.id
      );
      // 解构res.data
      const { result, data, msg } = res.data;
      // 判断请求是否成功
      if (result) {
        // 回显详情
        this.form = data;
        // 获取projectCode
        // 获取人员一览
      } else {
        // 提示请求失败消息
        this.$message.error(msg);
      }
    },
    /**
     * 富文本值发生变化时
     * @param {e} 富文本html
     * @author 滕威
     */
    fun_GetContent(e) {
      
    },
    /**
     * 退回采购人
     * @author 滕威
     */
    fun_Return() {
      // 打开确定按钮loading状态
      this.loadingBtn = true;
      (this.form.state = "th"),
        // 发起请求，获取结果集
        fun_PostAction("/purchaseContract/saveOrUpdate", this.form).then(
          res => {
            // 解构res.data
            const { result, msg } = res.data;
            // 判断请求是否成功
            if (result) {
              // 提示信息
              this.$message.success(msg);
              // 返回
              this.fun_Back();
            } else {
              // 提示请求失败消息
              this.$message.error(msg);
            }
            // 取消确定按钮loading状态
            this.loadingBtn = false;
          }
        );
    },
    /**
     * 盖章
     * @author 滕威
     */
    fun_Seal() {},

    /**
     * 赋值传值
     * @author 付翔
     */
    fun_AddList(e) {
      // 打开不良行为化标准一览弹窗
      this.dialogVisibles = true;
      this.fun_ProjectPerson();
    },
    /**
     * 获取采购单位/代理
     * @author 付翔
     */
    async fun_ProjectPerson() {
      let res = await fun_PostAction(
        "/winningPublicitySection/getWinningList",
        {
          ...this.searchForm,
          ...this.reqPageData
        }
      );
      // 解构res.data
      const { result, data, msg } = res.data;
      // 判断请求是否成功
      if (result) {
        const { records, total } = data;
        // 回显table
        this.tableData = records;
        // 回显分页总数
        this.total = total;
      } else {
        // 提示请求失败消息
        this.$message.error(msg);
      }
      // 关闭loading
      this.loading = false;
    },
    /**
     * 代理传值
     * @author 付翔
     */
    fun_LookDetails(e) {
      this.dialogVisibles = false;
      // 源id
      var oldId = this.form.id;
      // 给表单赋值
      this.form = e.val;
      // 给表单赋值
      this.form.id = oldId;
      // 给表单赋值
      this.form.sectionId = e.val.sectionCode;
    },
    /**
     * 上传合同
     * @author 滕威
     */
    fun_Upload() {
      if (!this.form.sectionId) {
        // 提示信息
        this.$message.error("请选择项目信息");
        return;
      }
      if (!this.form.contractNum) {
        // 提示信息
        this.$message.error("请填写合同号");
        return;
      }

      (this.form.state = "tj"),
        // 发起请求，获取结果集
        fun_PostAction("/purchaseContract/saveOrUpdate", this.form).then(
          res => {
            // 解构res.data
            const { result, msg } = res.data;
            // 判断请求是否成功
            if (result) {
              // 提示信息
              this.$message.success(msg);
              // 返回
              this.fun_Back();
            } else {
              // 提示请求失败消息
              this.$message.error(msg);
            }
            // 取消确定按钮loading状态
            this.loadingBtn = false;
          }
        );
    },
    /**
     * 查询
     * @author 滕威
     */
    fun_Search() {
      // 重置分页
      this.reqPageData = {
        current: 1, // 页码
        size: 10 // 每页条数
      };
      // 获取一览表格数据
      this.fun_GetList();
    },
    /**
     * 改变每页条数执行的函数
     * @params e 每页条数
     * @author 滕威
     */
    fun_LimitChange(e) {
      // 获取每页显示条数
      this.reqPageData.size = e;
      // 获取一览表格数据
      this.fun_GetList();
    },
    /**
     * 改变页码执行的函数
     * @params e 页码数
     * @author 滕威
     */
    fun_PageChange(e) {
      // 获取当前页码
      this.reqPageData.current = e;
      // 获取一览表格数据
      this.fun_GetList();
    },
    /**
     * 返回
     * @author 滕威
     */
    fun_Back() {
      this.$router.back();
    }
  }
};
